import { UserRoleType } from '@marvelapp/core';
export const copy = {
    [UserRoleType.Member]: {
        description: 'Can view, comment, or also create and edit all workspace projects and folders. Typically used for employees.',
        name: 'Team member',
        role: 'team members',
    },
    [UserRoleType.Guest]: {
        description: 'Can only access projects and folders that you specifically choose. Typically used for clients and freelancers',
        name: 'Contributor',
        role: 'contributors',
    },
};
export const ballparkCopy = {
    [UserRoleType.Member]: {
        description: 'Can view, comment, or also create and edit all workspace projects and folders. Typically used for employees.',
        name: 'Team member',
        role: 'team members',
    },
    [UserRoleType.Guest]: {
        description: 'Can only access projects that you specifically choose. Typically used for clients and stakeholders.',
        name: 'Guest',
        role: 'guest',
    },
};
export const testIds = {
    [UserRoleType.Member]: {
        testId: 'member-role-row',
        radioTestId: 'member-role',
    },
    [UserRoleType.Guest]: {
        testId: 'guest-role-row',
        radioTestId: 'guest-role',
    },
};
